import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseService } from './base.service';
import { ApiVersions } from './api-version';
import { CustomReportModel } from '../models/reports/custom-report.model';

@Injectable({
  providedIn: 'root'
})
export class CustomReportTemplateService extends BaseService {
  constructor() {
    super();
  }
  //will eventually need an API to refresh the cache
  private _cacheTemplates: CustomReportModel[];

  async getAllTemplates(): Promise<CustomReportModel[]> {
    if (!this._cacheTemplates) {
      this._cacheTemplates = await lastValueFrom(
        this.get('CustomReportTemplate', null, ApiVersions.v1_0)
      );
    }
    return this._cacheTemplates;
  }

  async getTemplate(customReportId: string): Promise<CustomReportModel> {
    return await lastValueFrom(
      this.get(`CustomReportTemplate/${customReportId}`, null, ApiVersions.v1_0)
    );
  }

  async saveTemplate(template: CustomReportModel): Promise<CustomReportModel> {
    this._cacheTemplates = null;
    return await lastValueFrom(
      this.post(`CustomReportTemplate/`, template, null, ApiVersions.v1_0)
    );
  }

  async updateStatus(
    customReportId: string,
    status: 'Active' | 'Inactive'
  ): Promise<CustomReportModel> {
    this._cacheTemplates = null;
    return await lastValueFrom(
      this.put(
        `CustomReportTemplate/${customReportId}/status`,
        `"${status}"`,
        null,
        ApiVersions.v1_0
      )
    );
  }

  async deleteTemplate(customReportId: string): Promise<boolean> {
    this._cacheTemplates = null;
    return await lastValueFrom(
      this.delete(`CustomReportTemplate/${customReportId}`, null, ApiVersions.v1_0)
    );
  }
}
